import React from 'react'

// Este componente es para mostrar la vista inicial vacía, solo con el navbar
const Index = () => {
    return (
        <div>
        </div>
    )
}

export default Index